export const sessionAuthURL = [
    '/auth/login',
    '/auth/forgotpass',
    'auth/resetpass'
];